import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import saveAs from 'file-saver';
import { toast, ToastContainer } from 'react-toastify';

import Button from '../../../common/components/Button';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const TestDownloadLink = (props: {
  testIdent: string | null | undefined;
}) => {
  const spd = useSpdCore();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const handleClick = () => {
    if (!props.testIdent) {
      return;
    }
    setIsLoading(true);
    const currentDate = new Date().toISOString().split('T')[0];
    spd.export
      .exportTest(props.testIdent)
      .then(blob => {
        if (blob) {
          saveAs(blob, `${props.testIdent}_${currentDate}.xlsx`);
          setIsLoading(false);
        }
      })
      .catch(async response => {
        const err = await responseErrors(response as ResponseError);
        toast.error(err?.[0]);
        setIsLoading(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <OverlayTrigger overlay={<Tooltip>Pobierz</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          isLoading={isLoading}
          variant="btn-info"
        >
          <Icon.Download />
        </Button>
      </OverlayTrigger>
    </>
  );
};
